import styled from 'styled-components';

const MobileSortMenuStyled = styled.div`
  fieldset {
    border: none;
    margin: 0;
    padding: 0;

    legend {
      align-items: center;
      background-color: var(--light-grey);
      color: var(--charcoal);
      display: flex;
      font-size: 1.4rem;
      font-weight: 800;
      letter-spacing: 0.07rem;
      line-height: 1.6rem;
      padding: 2.5rem 0rem 2.8rem 1.6rem;
      width: 100%;

      span {
        margin-right: 0.5rem;
      }
    }
  }

  .mobile-controls {
    background-color: var(--white);
    bottom: 0;
    box-shadow: 0px -40px 40px rgba(51, 51, 51, 0.1);
    display: flex;
    grid-gap: 0.8rem;
    padding: 1.6rem 1.6rem 2.4rem 1.6rem;
    position: absolute;
    width: 100%;

    div[class^='WidgetSpacingWrapper'] {
      flex: 1 1 auto;

      button {
        justify-content: center;
        width: 100%;
      }
    }
  }

  .filter-group {
    display: flex;
    margin: 1rem 0 1rem 0;
    width: 100%;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked ~ label {
        position: relative;
        &:before {
          content: 'done';
          font-display: swap;
          font-family: 'Material Icons';
          font-feature-settings: 'liga';
          font-weight: 700;
          left: -2.5rem;
          position: absolute;
        }
      }
    }

    label {
      font-size: 1.6rem;
      font-weight: 400;
      line-height: 2.4rem;
      margin-left: 4.5rem;
      cursor: pointer;
      width: 100%;
    }
  }
`;

export default MobileSortMenuStyled;
